import { AerialSourceEnum, GroupedFlightMapper } from "@zupper/data";

export class FlightNotificationModel {
  airline: AerialSourceEnum;
  flights: GroupedFlightMapper[];
  filterData: any;
}
